import(/* webpackMode: "eager" */ "/vercel/path0/app/[lng]/(authorization)/password-recovery/page.tsx");
